import React from "react";
import { Link } from 'react-router-dom';
import '../style/Setting.css';


export default function Setting() {
    return (
        <>
            <section className="section-11">
                <div className="box-t">
                    <Link className="link" to="/"><i class="fa-solid fa-arrow-left me-3"></i>Back</Link>
                    <h1 className="text-center">Settings</h1>
                </div>
                <img className="primg" src={require("../img/10.png")} alt="Error" />
                <div className="profile">
                    <div className="box-10_l">
                        <div className="pr">
                            <img className="pr-img" src={require("../img/10.png")} alt="Error" />
                            <p className="ms-1"><b className="fw-bold">Jaloliddin Esonboyev</b> <br />
                                ichbinabdulvoris@gmail.com</p>
                        </div>
                    </div>
                    <div className="box-10_r">
                    </div>
                </div>
                <div className="sec-11">
                    <div class="input-group mb-4">
                        <button type="button" class="btn btn-outline-secondary">Your name</button>
                        <ul class="dropdown-menu">
                            <li><a class="dropdown-item" href="#">Action</a></li>
                            <li><a class="dropdown-item" href="#">Another action</a></li>
                            <li><a class="dropdown-item" href="#">Something else here</a></li>
                            <li><hr class="dropdown-divider"/></li>
                            <li><a class="dropdown-item" href="#">Separated link</a></li>
                        </ul>
                        <input type="text" class="form-control" placeholder="Jaloliddin Esonboyev" aria-label="Text input with segmented dropdown button"/>
                        <button type="button" class="btn btn-outline-secondary dropdown-toggle dropdown-toggle-split" data-bs-toggle="dropdown" aria-expanded="false">
                            <span class="visually-hidden">Toggle Dropdown</span>
                        </button>
                    </div>

                    <div class="input-group mb-4">
                        <button type="button" class="btn btn-outline-secondary">Your name</button>
                        <ul class="dropdown-menu">
                            <li><a class="dropdown-item" href="#">Action</a></li>
                            <li><a class="dropdown-item" href="#">Another action</a></li>
                            <li><a class="dropdown-item" href="#">Something else here</a></li>
                            <li><hr class="dropdown-divider"/></li>
                            <li><a class="dropdown-item" href="#">Separated link</a></li>
                        </ul>
                        <input type="text" class="form-control" placeholder="Jaloliddin Esonboyev" aria-label="Text input with segmented dropdown button"/>
                        <button type="button" class="btn btn-outline-secondary dropdown-toggle dropdown-toggle-split" data-bs-toggle="dropdown" aria-expanded="false">
                            <span class="visually-hidden">Toggle Dropdown</span>
                        </button>
                    </div>

                    <div class="input-group mb-4">
                        <button type="button" class="btn btn-outline-secondary">Your name</button>
                        <ul class="dropdown-menu">
                            <li><a class="dropdown-item" href="#">Action</a></li>
                            <li><a class="dropdown-item" href="#">Another action</a></li>
                            <li><a class="dropdown-item" href="#">Something else here</a></li>
                            <li><hr class="dropdown-divider"/></li>
                            <li><a class="dropdown-item" href="#">Separated link</a></li>
                        </ul>
                        <input type="text" class="form-control" placeholder="Jaloliddin Esonboyev" aria-label="Text input with segmented dropdown button"/>
                        <button type="button" class="btn btn-outline-secondary dropdown-toggle dropdown-toggle-split" data-bs-toggle="dropdown" aria-expanded="false">
                            <span class="visually-hidden">Toggle Dropdown</span>
                        </button>
                    </div>

                    <div class="input-group mb-4">
                        <button type="button" class="btn btn-outline-secondary">Your name</button>
                        <ul class="dropdown-menu">
                            <li><a class="dropdown-item" href="#">Action</a></li>
                            <li><a class="dropdown-item" href="#">Another action</a></li>
                            <li><a class="dropdown-item" href="#">Something else here</a></li>
                            <li><hr class="dropdown-divider"/></li>
                            <li><a class="dropdown-item" href="#">Separated link</a></li>
                        </ul>
                        <input type="text" class="form-control" placeholder="Jaloliddin Esonboyev" aria-label="Text input with segmented dropdown button"/>
                        <button type="button" class="btn btn-outline-secondary dropdown-toggle dropdown-toggle-split" data-bs-toggle="dropdown" aria-expanded="false">
                            <span class="visually-hidden">Toggle Dropdown</span>
                        </button>
                    </div>

                    <div class="input-group mb-4">
                        <button type="button" class="btn btn-outline-secondary">Your name</button>
                        <ul class="dropdown-menu">
                            <li><a class="dropdown-item" href="#">Action</a></li>
                            <li><a class="dropdown-item" href="#">Another action</a></li>
                            <li><a class="dropdown-item" href="#">Something else here</a></li>
                            <li><hr class="dropdown-divider"/></li>
                            <li><a class="dropdown-item" href="#">Separated link</a></li>
                        </ul>
                        <input type="text" class="form-control" placeholder="Jaloliddin Esonboyev" aria-label="Text input with segmented dropdown button"/>
                        <button type="button" class="btn btn-outline-secondary dropdown-toggle dropdown-toggle-split" data-bs-toggle="dropdown" aria-expanded="false">
                            <span class="visually-hidden">Toggle Dropdown</span>
                        </button>
                    </div>
                    <Link to='/profil' className="linlog "><i class="fa-solid fa-arrow-right-from-bracket"></i> Log Out</Link>
                </div>
            </section>
        </>
    )
}